module.exports = __webpack_public_path__ + "static/media/reason-disburse-icon.9fb5b35b.svg";